import React, { useContext } from 'react';
import styles from './styles/MyClassroomsSidebar.module.css';
import { FaCalendarAlt, FaHome } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { ClassroomContext } from '../../context/ClassroomContext';
import { CALENDAR_PATH, useActiveClassroomId, useIsCalendarPage } from './classroomPaths';

const MyClassroomsSidebar = () => {
    const { classrooms, joinedClassrooms } = useContext(ClassroomContext);
    const classroomId = useActiveClassroomId();
    const isCalendarPage = useIsCalendarPage();

    return (
        <div className={styles.sidebarContainer}>
            <Link to="/my-classrooms" className={styles.navLink}>
                <div
                    className={`${styles.navItem} ${!classroomId && !isCalendarPage ? styles.navItemSelected : ''}`}
                >
                    <FaHome className={styles.navItemIcon} />Home
                </div>
            </Link>

            <Link to={CALENDAR_PATH} className={styles.navLink}>
                <div
                    className={`${styles.navItem} ${isCalendarPage ? styles.navItemSelected : ''}`}
                >
                    <FaCalendarAlt className={styles.navItemIcon} />Calendar
                </div>
            </Link>

            <div className={styles.sectionContainer}>
                <div className={styles.sectionTitle}>My Classrooms</div>
                <div className={styles.classroomList}>
                    {classrooms.slice().reverse().map((classroom) => (
                        <Link to={`/my-classrooms/${classroom._id}/d`} key={classroom._id} className={styles.navLink}>
                            <div
                                className={`${styles.navItem} ${classroomId === classroom._id ? styles.navItemSelected : ''}`}
                            >
                                {classroom.name}
                            </div>
                        </Link>
                    ))}
                </div>
            </div>

            <div className={styles.divider}></div>

            <div className={styles.sectionContainer}>
                <div className={styles.sectionTitle}>Joined Classrooms</div>
                <div className={styles.classroomList}>
                    {joinedClassrooms.slice().reverse().map((classroom) => (
                        <Link to={`/my-classrooms/${classroom._id}/d`} key={classroom._id} className={styles.navLink}>
                            <div
                                className={`${styles.navItem} ${classroomId === classroom._id ? styles.navItemSelected : ''}`}
                            >
                                {classroom.name}
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MyClassroomsSidebar;
